import * as actionType from "../constants/action_types";

const initialState = {
  provider: null,        // null=loading, []=not registered, [{...}]=registered
  agents: null,          // null=loading, []=no agents, [...]agents list
  isConnectSetup: null,    // null=loading, false=not registered, true=registered
};

const connectReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_CONNECT_PROVIDER_RES:
      const providerData = action?.payload?.data;
      return {
        ...state,
        provider: providerData ? providerData : {}
      };

    case actionType.GET_CONNECT_AGENT_RES:
      const agentRegistered = action?.payload?.data;
      return {
        ...state,
        agents: agentRegistered,
        isConnectSetup: Array.isArray(agentRegistered) && agentRegistered?.length > 0
      };

    case actionType.ADD_CONNECT_PROVIDER_RES:
      // Provider registration succeeded, saga will refetch via GET_CONNECT_PROVIDER_REQ
      return state;

    case actionType.ADD_CONNECT_AGENT_RES:
      // Agents added successfully, will be followed by refresh
      return state;

    default:
      return state;
  }
};

export { connectReducer };
